//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { BaseNomDTO } from '../ClientDTO';
import { OfficeDTO } from '../../core/ControlsApi/api';

export class SchedulerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
        this.instance.interceptors.request.use(
            config => {
                const token = localStorage.getItem('accessToken');
                if (token) {
                    if (!config.headers) {
                        config.headers = {};
                    }
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );
    }

    /**
     * @param currentDate (optional) 
     * @return Success
     */
    updateAppointmentStatus(appointmentId: number, appointmentStatusId: number, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/appointment/updateAppointmentStatus/{AppointmentId}/{AppointmentStatusId}";
        if (appointmentId === undefined || appointmentId === null)
            throw new Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{AppointmentId}", encodeURIComponent("" + appointmentId));
        if (appointmentStatusId === undefined || appointmentStatusId === null)
            throw new Error("The parameter 'appointmentStatusId' must be defined.");
        url_ = url_.replace("{AppointmentStatusId}", encodeURIComponent("" + appointmentStatusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAppointmentStatus(_response);
        });
    }

    protected processUpdateAppointmentStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
    getappointmentsbydate(currentDate: Date | undefined, cancelToken?: CancelToken | undefined): Promise<CalendarAppointmentDoctorDTO[]> {
        let url_ = this.baseUrl + "/appointment/getappointmentsbydate?";
        if (currentDate === null)
            throw new Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetappointmentsbydate(_response);
        });
    }

    protected processGetappointmentsbydate(response: AxiosResponse): Promise<CalendarAppointmentDoctorDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarAppointmentDoctorDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CalendarAppointmentDoctorDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarAppointmentDoctorDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    medicalprofiles( cancelToken?: CancelToken | undefined): Promise<MedicalProfileDTO[]> {
        let url_ = this.baseUrl + "/calendarfilters/medicalprofiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMedicalprofiles(_response);
        });
    }

    protected processMedicalprofiles(response: AxiosResponse): Promise<MedicalProfileDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicalProfileDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MedicalProfileDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MedicalProfileDTO[]>(null as any);
    }



    /**
     * @param searchTerm (optional) 
     * @param body (optional) 
     * @return Success
     */
    autocomplete(searchTerm: string | undefined, body: ClinicDTO[] | undefined, cancelToken?: CancelToken | undefined): Promise<DoctorDTO[]> {
        let url_ = this.baseUrl + "/calendarfilters/doctors/autocomplete?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutocomplete(_response);
        });
    }

    protected processAutocomplete(response: AxiosResponse): Promise<DoctorDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DoctorDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DoctorDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    clinics( cancelToken?: CancelToken | undefined): Promise<ClinicDTO[]> {
        let url_ = this.baseUrl + "/calendarfilters/clinics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClinics(_response);
        });
    }

    protected processClinics(response: AxiosResponse): Promise<ClinicDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClinicDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClinicDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */


    /**
     * @param clinic (optional) 
     * @param currentDate (optional) 
     * @return Success
     */

    /**
     * @param currentDate (optional) 
     * @return Success
     */


    /**
     * @param currentDate (optional) 
     * @param doctorId (optional) 
     * @return Success
     */


    /**
     * @return Success
     */
    schedulerblocktypes( cancelToken?: CancelToken | undefined): Promise<SchedulerBlockTypeDTO[]> {
        let url_ = this.baseUrl + "/daycalendar/schedulerblocktypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchedulerblocktypes(_response);
        });
    }

    protected processSchedulerblocktypes(response: AxiosResponse): Promise<SchedulerBlockTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SchedulerBlockTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SchedulerBlockTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchedulerBlockTypeDTO[]>(null as any);
    }

    /**
     * @param currentDate (optional) 
     * @param doctorId (optional) 
     * @return Success
     */
    /**
     * @param appointmentDoctorId (optional) 
     * @return Success
     */
    getappointmentById(appointmentDoctorId: number | undefined, cancelToken?: CancelToken | undefined): Promise<CalendarAppointmentDoctorDTO> {
        let url_ = this.baseUrl + "/daycalendar/actions/getappointmentById?";
        if (appointmentDoctorId === null)
            throw new Error("The parameter 'appointmentDoctorId' cannot be null.");
        else if (appointmentDoctorId !== undefined)
            url_ += "appointmentDoctorId=" + encodeURIComponent("" + appointmentDoctorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetappointmentById(_response);
        });
    }

    protected processGetappointmentById(response: AxiosResponse): Promise<CalendarAppointmentDoctorDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalendarAppointmentDoctorDTO.fromJS(resultData200);
            return Promise.resolve<CalendarAppointmentDoctorDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarAppointmentDoctorDTO>(null as any);
    }

    /**
     * @param currentMonth (optional) 
     * @param body (optional) 
     * @return Success
     */
    getclosestavailablefordaycalendar(currentMonth: Date | undefined, body: CalendarEventsByFiltersRequestDTO | undefined, cancelToken?: CancelToken | undefined): Promise<ClosestAvailableDateDTO[]> {
        let url_ = this.baseUrl + "/daycalendar/actions/getclosestavailablefordaycalendar?";
        if (currentMonth === null)
            throw new Error("The parameter 'currentMonth' cannot be null.");
        else if (currentMonth !== undefined)
            url_ += "currentMonth=" + encodeURIComponent(currentMonth ? "" + currentMonth.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetclosestavailablefordaycalendar(_response);
        });
    }

    protected processGetclosestavailablefordaycalendar(response: AxiosResponse): Promise<ClosestAvailableDateDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClosestAvailableDateDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClosestAvailableDateDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClosestAvailableDateDTO[]>(null as any);
    }

    /**
     * @param indentityNumber (optional) 
     * @return Success
     */
    patientbyIDNP(indentityNumber: string | undefined, cancelToken?: CancelToken | undefined): Promise<PatientDTO> {
        let url_ = this.baseUrl + "/daycalendar/actions/patientbyIDNP?";
        if (indentityNumber === null)
            throw new Error("The parameter 'indentityNumber' cannot be null.");
        else if (indentityNumber !== undefined)
            url_ += "indentityNumber=" + encodeURIComponent("" + indentityNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatientbyIDNP(_response);
        });
    }

    protected processPatientbyIDNP(response: AxiosResponse): Promise<PatientDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientDTO.fromJS(resultData200);
            return Promise.resolve<PatientDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientDTO>(null as any);
     }
    
    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getservicesautocomplete(searchTerm: string | undefined, cancelToken?: CancelToken | undefined): Promise<ServiceDTO[]> {
        let url_ = this.baseUrl + "/daycalendar/actions/getservicesautocomplete?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetservicesautocomplete(_response);
        });
    }

    protected processGetservicesautocomplete(response: AxiosResponse): Promise<ServiceDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ServiceDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAppointment(body: CalendarAppointmentDoctorDTO | undefined, cancelToken?: CancelToken | undefined): Promise<CalendarAppointmentDoctorDTO> {
        let url_ = this.baseUrl + "/daycalendar/actions/createAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAppointment(_response);
        });
    }

    protected processCreateAppointment(response: AxiosResponse): Promise<CalendarAppointmentDoctorDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalendarAppointmentDoctorDTO.fromJS(resultData200);
            return Promise.resolve<CalendarAppointmentDoctorDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarAppointmentDoctorDTO>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAppointment(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/daycalendar/actions/deleteAppointment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAppointment(_response);
        });
    }

    protected processDeleteAppointment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getclosesttimeforappointment( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/daycalendar/actions/getclosesttimeforappointment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetclosesttimeforappointment(_response);
        });
    }

    protected processGetclosesttimeforappointment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param currentMonth (optional) 
     * @param body (optional) 
     * @return Success
     */


    /**
     * @param currentMonth (optional) 
     * @return Success
     */


    /**
     * @param date (optional) 
     * @param body (optional) 
     * @return Success
     */


   

    /**
     * @param currentDate (optional) 
     * @param doctorId (optional) 
     * @return Success
     */

}

export class AddressDTO implements IAddressDTO {
    id?: number;
    districtId?: number;
    townId?: number | undefined;
    streetId?: number | undefined;
    streetNumber?: string | undefined;
    streetBlock?: string | undefined;
    appartment?: string | undefined;

    constructor(data?: IAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.districtId = _data["districtId"];
            this.townId = _data["townId"];
            this.streetId = _data["streetId"];
            this.streetNumber = _data["streetNumber"];
            this.streetBlock = _data["streetBlock"];
            this.appartment = _data["appartment"];
        }
    }

    static fromJS(data: any): AddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["districtId"] = this.districtId;
        data["townId"] = this.townId;
        data["streetId"] = this.streetId;
        data["streetNumber"] = this.streetNumber;
        data["streetBlock"] = this.streetBlock;
        data["appartment"] = this.appartment;
        return data;
    }
}

export interface IAddressDTO {
    id?: number;
    districtId?: number;
    townId?: number | undefined;
    streetId?: number | undefined;
    streetNumber?: string | undefined;
    streetBlock?: string | undefined;
    appartment?: string | undefined;
}

export class AppointmentStatusDTO implements IAppointmentStatusDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IAppointmentStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppointmentStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAppointmentStatusDTO {
    id?: number;
    name?: string | undefined;
}

export class CalendarAppointmentDoctorDTO implements ICalendarAppointmentDoctorDTO {
    id?: number;
    patientId?: number | undefined;
    patientName?: string | undefined;
    patientEmail?: string | undefined;
    patientIdentityNumber?: string | undefined;
    patientPhone?: string | undefined;
    patientBirthDate?: Date | undefined;
    doctorId?: number;
    doctorName?: string | undefined;
    consultationTypeId?: number | undefined;
    service?: ServiceDTO;
    dateStart?: Date;
    dateEnd?: Date;
    appointmentStatus?: AppointmentStatusDTO;
    clinic?: ClinicDTO;
    officeId?: number;
    checkUpId?: number | undefined;
    description?: string | undefined;
    schedulerBlockType?: SchedulerBlockTypeDTO;

    constructor(data?: ICalendarAppointmentDoctorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.patientName = _data["patientName"];
            this.patientEmail = _data["patientEmail"];
            this.patientIdentityNumber = _data["patientIdentityNumber"];
            this.patientPhone = _data["patientPhone"];
            this.patientBirthDate = _data["patientBirthDate"] ? new Date(_data["patientBirthDate"].toString()) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.doctorName = _data["doctorName"];
            this.consultationTypeId = _data["consultationTypeId"];
            this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>undefined;
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.appointmentStatus = _data["appointmentStatus"] ? AppointmentStatusDTO.fromJS(_data["appointmentStatus"]) : <any>undefined;
            this.clinic = _data["clinic"] ? ClinicDTO.fromJS(_data["clinic"]) : <any>undefined;
            this.officeId = _data["officeId"];
            this.checkUpId = _data["checkUpId"];
            this.description = _data["description"];
            this.schedulerBlockType = _data["schedulerBlockType"] ? SchedulerBlockTypeDTO.fromJS(_data["schedulerBlockType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CalendarAppointmentDoctorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarAppointmentDoctorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["patientName"] = this.patientName;
        data["patientEmail"] = this.patientEmail;
        data["patientIdentityNumber"] = this.patientIdentityNumber;
        data["patientPhone"] = this.patientPhone;
        data["patientBirthDate"] = this.patientBirthDate ? this.patientBirthDate.toISOString() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["doctorName"] = this.doctorName;
        data["consultationTypeId"] = this.consultationTypeId;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["appointmentStatus"] = this.appointmentStatus ? this.appointmentStatus.toJSON() : <any>undefined;
        data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>undefined;
        data["officeId"] = this.officeId;
        data["checkUpId"] = this.checkUpId;
        data["description"] = this.description;
        data["schedulerBlockType"] = this.schedulerBlockType ? this.schedulerBlockType.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICalendarAppointmentDoctorDTO {
    id?: number;
    patientId?: number | undefined;
    patientName?: string | undefined;
    patientEmail?: string | undefined;
    patientIdentityNumber?: string | undefined;
    patientPhone?: string | undefined;
    patientBirthDate?: Date | undefined;
    doctorId?: number;
    doctorName?: string | undefined;
    consultationTypeId?: number | undefined;
    service?: ServiceDTO;
    dateStart?: Date;
    dateEnd?: Date;
    appointmentStatus?: AppointmentStatusDTO;
    clinic?: ClinicDTO;
    officeId?: number;
    checkUpId?: number | undefined;
    description?: string | undefined;
    schedulerBlockType?: SchedulerBlockTypeDTO;
}

export class CalendarEventDTO implements ICalendarEventDTO {
    id?: string;
    display?: string | undefined;
    resourceId?: number | undefined;
    title?: string | undefined;
    backgroundColor?: string | undefined;
    start?: Date;
    end?: Date;
    color?: string | undefined;
    borderColor?: string | undefined;
    classNames?: string | undefined;
    createdBy?: number | undefined;
    extendedPropsCalendarEvent?: ExtendedPropsCalendarEventDTO;

    constructor(data?: ICalendarEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.display = _data["display"];
            this.resourceId = _data["resourceId"];
            this.title = _data["title"];
            this.backgroundColor = _data["backgroundColor"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.color = _data["color"];
            this.borderColor = _data["borderColor"];
            this.classNames = _data["classNames"];
            this.createdBy = _data["createdBy"];
            this.extendedPropsCalendarEvent = _data["extendedPropsCalendarEvent"] ? ExtendedPropsCalendarEventDTO.fromJS(_data["extendedPropsCalendarEvent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CalendarEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["display"] = this.display;
        data["resourceId"] = this.resourceId;
        data["title"] = this.title;
        data["backgroundColor"] = this.backgroundColor;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["borderColor"] = this.borderColor;
        data["classNames"] = this.classNames;
        data["createdBy"] = this.createdBy;
        data["extendedPropsCalendarEvent"] = this.extendedPropsCalendarEvent ? this.extendedPropsCalendarEvent.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICalendarEventDTO {
    id?: string;
    display?: string | undefined;
    resourceId?: number | undefined;
    title?: string | undefined;
    backgroundColor?: string | undefined;
    start?: Date;
    end?: Date;
    color?: string | undefined;
    borderColor?: string | undefined;
    classNames?: string | undefined;
    createdBy?: number | undefined;
    extendedPropsCalendarEvent?: ExtendedPropsCalendarEventDTO;
}

export class CalendarEventsByFiltersRequestDTO implements ICalendarEventsByFiltersRequestDTO {
    filters?: DoctorCalendarFiltersDTO;
    selectedDoctors?: DoctorDTO[] | undefined;
    duration?: number | undefined;

    constructor(data?: ICalendarEventsByFiltersRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? DoctorCalendarFiltersDTO.fromJS(_data["filters"]) : <any>undefined;
            if (Array.isArray(_data["selectedDoctors"])) {
                this.selectedDoctors = [] as any;
                for (let item of _data["selectedDoctors"])
                    this.selectedDoctors!.push(DoctorDTO.fromJS(item));
            }
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): CalendarEventsByFiltersRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventsByFiltersRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedDoctors)) {
            data["selectedDoctors"] = [];
            for (let item of this.selectedDoctors)
                data["selectedDoctors"].push(item.toJSON());
        }
        data["duration"] = this.duration;
        return data;
    }
}

export interface ICalendarEventsByFiltersRequestDTO {
    filters?: DoctorCalendarFiltersDTO;
    selectedDoctors?: DoctorDTO[] | undefined;
    duration?: number | undefined;
}

export class CalendarPatientDTO implements ICalendarPatientDTO {
    id?: number;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;

    constructor(data?: ICalendarPatientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CalendarPatientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarPatientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ICalendarPatientDTO {
    id?: number;
    email?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
}

export class ClinicDTO implements IClinicDTO {
    id?: number;
    name?: string | undefined;
    shortName?: string | undefined;

    constructor(data?: IClinicDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): ClinicDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IClinicDTO {
    id?: number;
    name?: string | undefined;
    shortName?: string | undefined;
}

export class ClosestAvailableDateDTO implements IClosestAvailableDateDTO {
    doctor?: DoctorDTO;
    startDateTime?: Date;

    constructor(data?: IClosestAvailableDateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctor = _data["doctor"] ? DoctorDTO.fromJS(_data["doctor"]) : <any>undefined;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClosestAvailableDateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClosestAvailableDateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClosestAvailableDateDTO {
    doctor?: DoctorDTO;
    startDateTime?: Date;
}

export class DayCalendarConfigurationDTO implements IDayCalendarConfigurationDTO {
    workTimeFrom?: number;
    workTimeTo?: number;

    constructor(data?: IDayCalendarConfigurationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workTimeFrom = _data["workTimeFrom"];
            this.workTimeTo = _data["workTimeTo"];
        }
    }

    static fromJS(data: any): DayCalendarConfigurationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DayCalendarConfigurationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workTimeFrom"] = this.workTimeFrom;
        data["workTimeTo"] = this.workTimeTo;
        return data;
    }
}

export interface IDayCalendarConfigurationDTO {
    workTimeFrom?: number;
    workTimeTo?: number;
}

export class DoctorCalendarFiltersDTO implements IDoctorCalendarFiltersDTO {
    medicalProfiles?: MedicalProfileDTO[] | undefined;
    clinics?: ClinicDTO[] | undefined;

    constructor(data?: IDoctorCalendarFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["medicalProfiles"])) {
                this.medicalProfiles = [] as any;
                for (let item of _data["medicalProfiles"])
                    this.medicalProfiles!.push(MedicalProfileDTO.fromJS(item));
            }
            if (Array.isArray(_data["clinics"])) {
                this.clinics = [] as any;
                for (let item of _data["clinics"])
                    this.clinics!.push(ClinicDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DoctorCalendarFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorCalendarFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.medicalProfiles)) {
            data["medicalProfiles"] = [];
            for (let item of this.medicalProfiles)
                data["medicalProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.clinics)) {
            data["clinics"] = [];
            for (let item of this.clinics)
                data["clinics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDoctorCalendarFiltersDTO {
    medicalProfiles?: MedicalProfileDTO[] | undefined;
    clinics?: ClinicDTO[] | undefined;
}

export class DoctorDTO implements IDoctorDTO {
    id?: number;
    person?: PersonDTO;
    medicalProfile?: MedicalProfileDTO;
    employee?: EmployeeDTO;

    constructor(data?: IDoctorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.person = _data["person"] ? PersonDTO.fromJS(_data["person"]) : <any>undefined;
            this.medicalProfile = _data["medicalProfile"] ? MedicalProfileDTO.fromJS(_data["medicalProfile"]) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeDTO.fromJS(_data["employee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DoctorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["medicalProfile"] = this.medicalProfile ? this.medicalProfile.toJSON() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDoctorDTO {
    id?: number;
    person?: PersonDTO;
    medicalProfile?: MedicalProfileDTO;
    employee?: EmployeeDTO;
}

export class EmployeeDTO implements IEmployeeDTO {
    id?: number;
    person?: PersonDTO;
    clinics?: ClinicDTO[] | undefined;

    constructor(data?: IEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.person = _data["person"] ? PersonDTO.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["clinics"])) {
                this.clinics = [] as any;
                for (let item of _data["clinics"])
                    this.clinics!.push(ClinicDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.clinics)) {
            data["clinics"] = [];
            for (let item of this.clinics)
                data["clinics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeeDTO {
    id?: number;
    person?: PersonDTO;
    clinics?: ClinicDTO[] | undefined;
}

export class ExtendedProps implements IExtendedProps {
    doctor?: DoctorDTO;

    constructor(data?: IExtendedProps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctor = _data["doctor"] ? DoctorDTO.fromJS(_data["doctor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtendedProps {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedProps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtendedProps {
    doctor?: DoctorDTO;
}

export class ExtendedPropsCalendarEventDTO implements IExtendedPropsCalendarEventDTO {
    appointmentId?: number | undefined;
    schedulerBlockTypeName?: string | undefined;
    schedulerBlockTypeId?: number;
    schedulerBlockType?: SchedulerBlockTypeDTO;
    appointmentDoctorId?: number | undefined;
    patient?: CalendarPatientDTO;
    doctorName?: string | undefined;
    clinic?: ClinicDTO;
    service?: ServiceDTO;
    appointmentStatus?: AppointmentStatusDTO;

    constructor(data?: IExtendedPropsCalendarEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.schedulerBlockTypeName = _data["schedulerBlockTypeName"];
            this.schedulerBlockTypeId = _data["schedulerBlockTypeId"];
            this.schedulerBlockType = _data["schedulerBlockType"] ? SchedulerBlockTypeDTO.fromJS(_data["schedulerBlockType"]) : <any>undefined;
            this.appointmentDoctorId = _data["appointmentDoctorId"];
            this.patient = _data["patient"] ? CalendarPatientDTO.fromJS(_data["patient"]) : <any>undefined;
            this.doctorName = _data["doctorName"];
            this.clinic = _data["clinic"] ? ClinicDTO.fromJS(_data["clinic"]) : <any>undefined;
            this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>undefined;
            this.appointmentStatus = _data["appointmentStatus"] ? AppointmentStatusDTO.fromJS(_data["appointmentStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtendedPropsCalendarEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedPropsCalendarEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["schedulerBlockTypeName"] = this.schedulerBlockTypeName;
        data["schedulerBlockTypeId"] = this.schedulerBlockTypeId;
        data["schedulerBlockType"] = this.schedulerBlockType ? this.schedulerBlockType.toJSON() : <any>undefined;
        data["appointmentDoctorId"] = this.appointmentDoctorId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["doctorName"] = this.doctorName;
        data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["appointmentStatus"] = this.appointmentStatus ? this.appointmentStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtendedPropsCalendarEventDTO {
    appointmentId?: number | undefined;
    schedulerBlockTypeName?: string | undefined;
    schedulerBlockTypeId?: number;
    schedulerBlockType?: SchedulerBlockTypeDTO;
    appointmentDoctorId?: number | undefined;
    patient?: CalendarPatientDTO;
    doctorName?: string | undefined;
    clinic?: ClinicDTO;
    service?: ServiceDTO;
    appointmentStatus?: AppointmentStatusDTO;
}
export interface ISamplingScheduleOptionDTO {
    service?: ServiceDTO;
    startDate?: Date | null;
    endDate?: Date | null;
    samplingOffice?: SamplingOfficeDTO;
    office?: OfficeDTO;
    notAvailable?: boolean | null;
}

export class SamplingScheduleOptionDTO implements ISamplingScheduleOptionDTO {
    service?: ServiceDTO;
    startDate?: Date | null;
    endDate?: Date | null;
    samplingOffice?: SamplingOfficeDTO;
    office?: OfficeDTO;
    notAvailable?: boolean | null;

    constructor(data?: ISamplingScheduleOptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>null;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.samplingOffice = _data["samplingOffice"] ? SamplingOfficeDTO.fromJS(_data["samplingOffice"]) : <any>null;
            this.office = _data["office"] ? OfficeDTO.fromJS(_data["office"]) : <any>null;
            this.notAvailable = _data["notAvailable"] !== undefined ? _data["notAvailable"] : <any>null;
        }
    }

    static fromJS(data: any): SamplingScheduleOptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SamplingScheduleOptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["samplingOffice"] = this.samplingOffice ? this.samplingOffice.toJSON() : <any>null;
        data["office"] = this.office ? this.office.toJSON() : <any>null;
        data["notAvailable"] = this.notAvailable !== undefined ? this.notAvailable : <any>null;
        return data;
    }
}
export class SamplingOfficeDTO implements ISamplingOfficeDTO {
    id?: number;
    writeRevision?: boolean | null;
    clinic?: ClinicDTO;
    office?: OfficeDTO;
    name?: string | null;

    constructor(data?: ISamplingOfficeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.clinic = _data["clinic"] ? ClinicDTO.fromJS(_data["clinic"]) : <any>null;
            this.office = _data["office"] ? OfficeDTO.fromJS(_data["office"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SamplingOfficeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SamplingOfficeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>null;
        data["office"] = this.office ? this.office.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ISamplingOfficeDTO {
    id?: number;
    writeRevision?: boolean | null;
    clinic?: ClinicDTO;
    office?: OfficeDTO;
    name?: string | null;
}


export class GridCalendarEventDTO implements IGridCalendarEventDTO {
    id?: string | undefined;
    title?: string | undefined;
    start?: Date;
    end?: Date;
    allDay?: boolean;
    color?: string | undefined;
    backgroundColor?: string | undefined;
    borderColor?: string | undefined;
    resourceId?: string | undefined;
    textColor?: string | undefined;

    constructor(data?: IGridCalendarEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.allDay = _data["allDay"];
            this.color = _data["color"];
            this.backgroundColor = _data["backgroundColor"];
            this.borderColor = _data["borderColor"];
            this.resourceId = _data["resourceId"];
            this.textColor = _data["textColor"];
        }
    }

    static fromJS(data: any): GridCalendarEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GridCalendarEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["allDay"] = this.allDay;
        data["color"] = this.color;
        data["backgroundColor"] = this.backgroundColor;
        data["borderColor"] = this.borderColor;
        data["resourceId"] = this.resourceId;
        data["textColor"] = this.textColor;
        return data;
    }
}

export interface IGridCalendarEventDTO {
    id?: string | undefined;
    title?: string | undefined;
    start?: Date;
    end?: Date;
    allDay?: boolean;
    color?: string | undefined;
    backgroundColor?: string | undefined;
    borderColor?: string | undefined;
    resourceId?: string | undefined;
    textColor?: string | undefined;
}

export class MedicalProfileDTO implements IMedicalProfileDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IMedicalProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MedicalProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMedicalProfileDTO {
    id?: number;
    name?: string | undefined;
}

export class MonthCalendarEventDTO implements IMonthCalendarEventDTO {
    title?: string | undefined;
    start?: Date;
    display?: string | undefined;
    allDay?: boolean;
    color?: string | undefined;
    extendedProps?: ExtendedProps;

    constructor(data?: IMonthCalendarEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.display = _data["display"];
            this.allDay = _data["allDay"];
            this.color = _data["color"];
            this.extendedProps = _data["extendedProps"] ? ExtendedProps.fromJS(_data["extendedProps"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MonthCalendarEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthCalendarEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["display"] = this.display;
        data["allDay"] = this.allDay;
        data["color"] = this.color;
        data["extendedProps"] = this.extendedProps ? this.extendedProps.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMonthCalendarEventDTO {
    title?: string | undefined;
    start?: Date;
    display?: string | undefined;
    allDay?: boolean;
    color?: string | undefined;
    extendedProps?: ExtendedProps;
}

export class PatientCategoryDTO implements IPatientCategoryDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPatientCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PatientCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPatientCategoryDTO {
    id?: number;
    name?: string | undefined;
}

export class PatientDTO implements IPatientDTO {
    id?: number;
    personId?: number;
    person?: PersonDTO;
    email?: string | undefined;
    phone?: string | undefined;
    maritalStatusId?: number | undefined;
    citizenshipId?: number | undefined;
    bloodGroupId?: number | undefined;
    rhId?: number | undefined;
    patientCategoryId?: number;
    patientCategory?: PatientCategoryDTO;
    addressId?: number | undefined;
    address?: AddressDTO;
    profession?: string | undefined;
    job?: string | undefined;
    studies?: string | undefined;

    constructor(data?: IPatientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? PersonDTO.fromJS(_data["person"]) : <any>undefined;
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.citizenshipId = _data["citizenshipId"];
            this.bloodGroupId = _data["bloodGroupId"];
            this.rhId = _data["rhId"];
            this.patientCategoryId = _data["patientCategoryId"];
            this.patientCategory = _data["patientCategory"] ? PatientCategoryDTO.fromJS(_data["patientCategory"]) : <any>undefined;
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? AddressDTO.fromJS(_data["address"]) : <any>undefined;
            this.profession = _data["profession"];
            this.job = _data["job"];
            this.studies = _data["studies"];
        }
    }

    static fromJS(data: any): PatientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["maritalStatusId"] = this.maritalStatusId;
        data["citizenshipId"] = this.citizenshipId;
        data["bloodGroupId"] = this.bloodGroupId;
        data["rhId"] = this.rhId;
        data["patientCategoryId"] = this.patientCategoryId;
        data["patientCategory"] = this.patientCategory ? this.patientCategory.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["profession"] = this.profession;
        data["job"] = this.job;
        data["studies"] = this.studies;
        return data;
    }
}

export interface IPatientDTO {
    id?: number;
    personId?: number;
    person?: PersonDTO;
    email?: string | undefined;
    phone?: string | undefined;
    maritalStatusId?: number | undefined;
    citizenshipId?: number | undefined;
    bloodGroupId?: number | undefined;
    rhId?: number | undefined;
    patientCategoryId?: number;
    patientCategory?: PatientCategoryDTO;
    addressId?: number | undefined;
    address?: AddressDTO;
    profession?: string | undefined;
    job?: string | undefined;
    studies?: string | undefined;
}

export class PersonDTO implements IPersonDTO {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    patronymic?: string | undefined;
    birthDate?: Date | undefined;
    sexId?: number | undefined;
    identityNumber?: string | undefined;

    constructor(data?: IPersonDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.patronymic = _data["patronymic"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.sexId = _data["sexId"];
            this.identityNumber = _data["identityNumber"];
        }
    }

    static fromJS(data: any): PersonDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["patronymic"] = this.patronymic;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sexId"] = this.sexId;
        data["identityNumber"] = this.identityNumber;
        return data;
    }
}

export interface IPersonDTO {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    patronymic?: string | undefined;
    birthDate?: Date | undefined;
    sexId?: number | undefined;
    identityNumber?: string | undefined;
}

export class SchedulerBlockTypeDTO implements ISchedulerBlockTypeDTO {
    id?: number;
    name?: string | undefined;
    color?: string | undefined;
    isSchedule?: boolean | undefined;
    isServiceBlock?: boolean | undefined;
    isVacation?: boolean | undefined;
    isUrgent?: boolean | undefined;
    isClinic?: boolean | undefined;

    constructor(data?: ISchedulerBlockTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.isSchedule = _data["isSchedule"];
            this.isServiceBlock = _data["isServiceBlock"];
            this.isVacation = _data["isVacation"];
            this.isUrgent = _data["isUrgent"];
            this.isClinic = _data["isClinic"];
        }
    }

    static fromJS(data: any): SchedulerBlockTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerBlockTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["isSchedule"] = this.isSchedule;
        data["isServiceBlock"] = this.isServiceBlock;
        data["isVacation"] = this.isVacation;
        data["isUrgent"] = this.isUrgent;
        data["isClinic"] = this.isClinic;
        return data;
    }
}

export interface ISchedulerBlockTypeDTO {
    id?: number;
    name?: string | undefined;
    color?: string | undefined;
    isSchedule?: boolean | undefined;
    isServiceBlock?: boolean | undefined;
    isVacation?: boolean | undefined;
    isUrgent?: boolean | undefined;
    isClinic?: boolean | undefined;
}

export class ParentServiceTypeDTO implements IParentServiceTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;

    constructor(data?: IParentServiceTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ParentServiceTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ParentServiceTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IParentServiceTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
}

export class ServiceDTO implements IServiceDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    shortName?: string | null;
    serviceTypeDTO?: ServiceTypeDTO;
    serviceType?: BaseNomDTO;
    duration?: number | null;
    showAllDiscounts?: boolean | null;
    price?: number | null;
    dateCreated?: Date | null;
    serviceCode?: string | null;
    tvaRate?: TVARateDTO;

    constructor(data?: IServiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.serviceTypeDTO = _data["serviceTypeDTO"] ? ServiceTypeDTO.fromJS(_data["serviceTypeDTO"]) : <any>null;
            this.serviceType = _data["serviceType"] ? BaseNomDTO.fromJS(_data["serviceType"]) : <any>null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            this.showAllDiscounts = _data["showAllDiscounts"] !== undefined ? _data["showAllDiscounts"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>null;
            this.serviceCode = _data["serviceCode"] !== undefined ? _data["serviceCode"] : <any>null;
            this.tvaRate = _data["tvaRate"] ? TVARateDTO.fromJS(_data["tvaRate"]) : <any>null;
        }
    }

    static fromJS(data: any): ServiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["serviceTypeDTO"] = this.serviceTypeDTO ? this.serviceTypeDTO.toJSON() : <any>null;
        data["serviceType"] = this.serviceType ? this.serviceType.toJSON() : <any>null;
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        data["showAllDiscounts"] = this.showAllDiscounts !== undefined ? this.showAllDiscounts : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>null;
        data["serviceCode"] = this.serviceCode !== undefined ? this.serviceCode : <any>null;
        data["tvaRate"] = this.tvaRate ? this.tvaRate.toJSON() : <any>null;
        return data;
    }
}

export interface IServiceDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    shortName?: string | null;
    serviceTypeDTO?: ServiceTypeDTO;
    serviceType?: BaseNomDTO;
    duration?: number | null;
    showAllDiscounts?: boolean | null;
    price?: number | null;
    dateCreated?: Date | null;
    serviceCode?: string | null;
    tvaRate?: TVARateDTO;
}

export class ServiceTypeDTO implements IServiceTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    parentServiceTypeDTO?: ParentServiceTypeDTO;
    parentServiceType?: BaseNomDTO;

    constructor(data?: IServiceTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.parentServiceTypeDTO = _data["parentServiceTypeDTO"] ? ParentServiceTypeDTO.fromJS(_data["parentServiceTypeDTO"]) : <any>null;
            this.parentServiceType = _data["parentServiceType"] ? BaseNomDTO.fromJS(_data["parentServiceType"]) : <any>null;
        }
    }

    static fromJS(data: any): ServiceTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["parentServiceTypeDTO"] = this.parentServiceTypeDTO ? this.parentServiceTypeDTO.toJSON() : <any>null;
        data["parentServiceType"] = this.parentServiceType ? this.parentServiceType.toJSON() : <any>null;
        return data;
    }
}

export interface IServiceTypeDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    parentServiceTypeDTO?: ParentServiceTypeDTO;
    parentServiceType?: BaseNomDTO;
}

export class TVARateDTO implements ITVARateDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    rate?: number | null;

    constructor(data?: ITVARateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): TVARateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TVARateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        return data;
    }
}

export interface ITVARateDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    tag?: string | null;
    color?: string | null;
    rate?: number | null;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}